// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
    production: false,
    path: '',
    pathMotor: '',
    apiUrl: 'https://axd341sas12jf.enjoy.cl',
    enjoyBackend: 'https://axd341sas12jf.enjoy.cl',
    api_baseurl_token: 'https://axd341sas12jf.enjoy.cl/ecc.token.web',
    api_baseurl_ecc_socios: 'https://axd341sas12jf.enjoy.cl/ecc.socios.secure',
    api_baseurl_ecc_transversal: 'https://axd341sas12jf.enjoy.cl/ecc.transversal.secure',
    pagination: {
        espectaculos: {
            itemsPerPage: {
                mobile: 6,
                desktop: 3
            },
            itemsPerSlide: {
                mobile: 1,
                desktop: 3
            }
        }
    },
    service: {
        links: {
            public: false,
            nameservice: 'links',
            endpoint: '/crm.transversal/api/cms/Transversal/Parametro/'
        },
        parametrosConfiguracion: {
            public: false,
            nameservice: 'parametrosConfiguracion',
            endpoint: '/crm.transversal/api/cms/Transversal/Parametro'
        },
        unidades: {
            public: false,
            nameservice: 'unidades',
            endpoint: '/crm.transversal/api/cms/Transversal/Unidad/GetUnidades'
        },
        unidadesOtros: {
            public: false,
            nameservice: 'unidades',
            endpoint: '/crm.baseslegales/api/cms/BasesLegales/GetUnidades'
        },
        redesSociales: {
            public: false,
            nameService: 'redesSociales',
            endpoint: '/crm.transversal/api/cms/Transversal/Unidad/GetRedesSociales'
        },
        canales: {
            public: false,
            nameservice: 'canales',
            endpoint: '/motor.canal/api/Canal/pais'
        },
        listaSelectFormulario: {
            public: false,
            nameservice: 'listaSelectFormulario',
            endpoint: '/crm.transversal/api/cms/Transversal/Listas/GetListas'
        },
        etiquetasFooter: {
            public: false,
            nameservice: 'etiquetasFooter',
            endpoint: '/crm.footer/api/cms/Footer/GetLista'
        },
        seccionHeader: {
            public: false,
            nameservice: 'seccionHeader',
            endpoint: '/crm.secciones/api/cms/Secciones/Seccion'
        },
        seccionEspectaculos: {
            public: false,
            nameservice: 'seccionEspectaculos',
            endpoint: '/crm.secciones/api/cms/Secciones/Seccion'
        },
        seccionPromociones: {
            public: false,
            nameservice: 'seccionPromociones',
            endpoint: '/crm.secciones/api/cms/Secciones/Seccion'
        },
        seccionBanners: {
            public: false,
            nameservice: 'seccionBanners',
            endpoint: '/crm.contenidos/api/cms/Contenido/GetContenidos'
        },
        seccionHazteSocio: {
            public: false,
            nameservice: 'seccionHazteSocio',
            endpoint: '/crm.contenidos/api/cms/Contenido/GetContenidos'
        },
        espectaculosEnjoyUnidad: {
            public: false,
            nameservice: 'espectaculosEnjoyUnidad',
            endpoint: '/crm.espectaculos/api/cms/Espectaculos/Espectaculo/GetEspectaculosUnidades'
        },

        espectaculosMasEnjoy: {
            public: false,
            nameservice: 'espectaculosMasEnjoy',
            endpoint: '/crm.espectaculos/api/cms/Espectaculos/Espectaculo/GetMasEspectaculos'
        },

        filterCategorias: {
            public: false,
            nameservice: 'filterCategorias',
            endpoint: '/crm.transversal/api/cms/Transversal/Parametro/GetCategorias'
        },
        listaCategorias: {
            public: false,
            nameservice: 'listaCategorias',
            endpoint: '/crm.transversal/api/cms/Transversal/Categoria'
        },
        detailEspectaculo: {
            public: false,
            nameservice: 'detailEspectaculo',
            endpoint: '/crm.espectaculos/api/cms/Espectaculos/Espectaculo/GetEspectaculo'
        },
        allPromociones: {
            public: false,
            nameservice: 'allPromociones',
            endpoint: '/crm.promociones/api/cms/Promociones/Promocion/GetCasinoPromocionesFull'
        },
        promocionesEnjoyCL: {
            public: false,
            nameservice: 'promocionesEnjoyCL',
            endpoint: '/crm.promociones/api/cms/Promociones/Promocion/GetUnidadPromociones'
        },
        detailPromocion: {
            public: false,
            nameservice: 'detailPromocion',
            endpoint: '/crm.promociones/api/cms/Promociones/Promocion/GetPromocion'
        },
        verMasPromociones: {
            public: false,
            nameservice: 'verMasPromociones',
            endpoint: '/crm.promociones/api/cms/Promociones/Promocion/GetMasPromociones'
        },
        entretenimientoSostenible: {
            public: false,
            nameservice: 'entretenimientoSostenible',
            endpoint: '/crm.legales/api/cms/EntretenimientoSostenible'
        },
        pdfReporteSostenibilidad: {
            public: false,
            nameservice: 'pdfReporteSostenibilidad',
            endpoint: '/crm.sostenibilidad/api/cms/ReporteSostenibilidad'
        },
        terminosCondiciones: {
            public: false,
            nameservice: 'terminosCondiciones',
            endpoint: '/crm.legales/api/cms/TerminosCondiciones'
        },
        politicaPrivacidad: {
            public: false,
            nameservice: 'politicaPrivacidad',
            endpoint: '/crm.legales/api/cms/PoliticaPrivacidad'
        },
        juegoResponsable: {
            public: false,
            nameservice: 'juegoResponsable',
            endpoint: '/crm.legales/api/cms/JuegoResponsable'
        },
        pdfJuegoResponsable: {
            public: false,
            nameservice: 'pdfJuegoResponsable',
            endpoint: '/crm.formularios/api/cms/Formularios'
        },
        aniosBasesLegales: {
            public: false,
            nameservice: 'aniosBasesLegales',
            endpoint: '/crm.baseslegales/api/cms/BasesLegales/GetAnios'
        },
        aniosBasesLegalesOtros: {
            public: false,
            nameservice: 'aniosBasesLegalesOtros',
            endpoint: '/crm.baseslegales/api/cms/BasesLegales/GetAnios'
        },
        basesLegales: {
            public: false,
            nameservice: 'basesLegales',
            endpoint: '/crm.baseslegales/api/cms/BasesLegales/GetPromocionesBasesLegales'
        },
        basesLegalesOtros: {
            public: false,
            nameservice: 'basesLegales',
            endpoint: '/crm.baseslegales/api/cms/BasesLegales/GetBasesLegalesAll'
        },
        galeriaNosotros: {
            public: false,
            nameservice: 'galeriaNosotros',
            endpoint: '/crm.footer/api/cms/Footer/GetNosotros'
        },
        galeriaDocLegales: {
            public: false,
            nameservice: 'galeriaDocLegales',
            endpoint: '/crm.footer/api/cms/Footer/GetDocLegales'
        },
        galeriaProveedores: {
            public: false,
            nameservice: 'galeriaProveedores',
            endpoint: '/crm.footer/api/cms/Footer/GetProveedores'
        },
        preguntasFrecuentes: {
            public: false,
            nameservice: 'preguntasFrecuentes',
            endpoint: '/crm.footer/api/cms/Footer/GetPreguntasFrecuentesProveedores'
        },
        quieroSerProveedor: {
            public: false,
            nameservice: 'quieroSerProveedor',
            endpoint: '/crm.footer/api/cms/Proveedores/GetFormulario'
        },
        yaSoyProveedor: {
            public: false,
            nameservice: 'yaSoyProveedor',
            endpoint: '/crm.footer/api/cms/Proveedores/GetInformacion'
        },
        misionVisionValores: {
            public: false,
            nameservice: 'misionVisionValores',
            endpoint: '/crm.footer/api/cms/Nosotros/GetMisionVisionValores'
        },
        programaFidelizacion: {
            public: false,
            nameservice: 'programaFidelizacion',
            endpoint: '/crm.footer/api/cms/Nosotros/GetProgramaFidelizacion'
        },
        memoriasYReportes: {
            public: false,
            nameservice: 'memoriasYReportes',
            endpoint: '/crm.footer/api/cms/Nosotros/GetMemoriasReportes'
        },
        pdfMemoriaYReporte: {
            public: false,
            nameservice: 'pdfMemoriaYReporte',
            endpoint: '/crm.memoria/api/cms/MemoriaAnual'
        },
        serviciosUnidad: {
            public: false,
            nameservice: 'serviciosUnidad',
            endpoint: '/crm.unidad/api/cms/Unidad/GetMenu'
        },
        serviciosUnidadData: {
            public: false,
            nameservice: 'serviciosUnidadData',
            endpoint: '/crm.unidad/api/cms/Unidad/GetMenuData'
        },
        headerUnidad: {
            public: false,
            nameservice: 'headerUnidad',
            endpoint: '/crm.secciones/api/cms/Secciones/Seccion/GetUnidadHeader'
        },
        promocionesDestacadasUnidad: {
            public: false,
            nameservice: 'promocionesDestacadasUnidad',
            endpoint: '/crm.secciones/api/cms/Secciones/Seccion/GetUnidadPromociones'
        },
        espectaculosDestacadosUnidad: {
            public: false,
            nameservice: 'espectaculosDestacadosUnidad',
            endpoint: '/crm.secciones/api/cms/Secciones/Seccion/GetUnidadEspectaculos'
        },
        itemCalendario: {
            public: false,
            nameservice: 'itemCalendario',
            endpoint: '/crm.secciones/api/cms/Secciones/Seccion/GetUnidadEspectaculosCalendario'
        },
        contenidoCasinoUnidad: {
            public: false,
            nameservice: 'contenidoCasinoUnidad',
            endpoint: '/crm.unidad/api/cms/Casino/GetCasino'
        },
        casinoPromociones: {
            public: false,
            nameService: 'casinoPromociones',
            endpoint: '/crm.promociones/api/cms/Promociones/Promocion/GetCasinoPromociones'
        },
        contenidoBannerUnidad: {
            public: false,
            nameservice: 'contenidoBannerUnidad',
            endpoint: '/crm.unidad/api/cms/Unidad/GetUnidadBanners'
        },
        contenidoHotelUnidad: {
            public: false,
            nameservice: 'contenidoHotelUnidad',
            endpoint: '/crm.unidad/api/cms/Hotel/GetHotel'
        },
        contenidoDetalleHabitacion: {
            public: false,
            nameservice: 'detalleHabitacion',
            endpoint: '/crm.unidad/api/cms/Hotel/GetHabitacion'
        },
        contenidoDetalleJuego: {
            public: false,
            nameservice: 'contenidoDetalleJuego',
            endpoint: '/crm.unidad/api/cms/Casino/GetCasinoJuego'
        },
        contenidoDetalleRestaurant: {
            public: false,
            nameService: 'contenidoDetalleRestaurant',
            endpoint: '/crm.unidad/api/cms/Gastronomia/GetRestaurant'
        },
        contenidoGastronomiaUnidad: {
            public: false,
            nameService: 'contenidoGastronomiaUnidad',
            endpoint: '/crm.unidad/api/cms/Gastronomia/GetGastronomia'
        },
        contenidoSpaUnidad: {
            public: false,
            nameservice: 'contenidoSpaUnidad',
            endpoint: '/crm.unidad/api/cms/Spa/GetSpa'
        },
        contenidoDiscotequeUnidad: {
            public: false,
            nameservice: 'contenidoSpaUncontenidoDiscotequeUnidadidad',
            endpoint: '/crm.unidad/api/cms/Ovo/GetOvo'
        },
        contenidoNegocioUnidad: {
            public: false,
            nameservice: 'contenidoDetalleCentroNegocios',
            endpoint: '/crm.unidad/api/cms/CentroNegocios/GetCentroNegocios'
        },
        contenidoDetalleUnidad: {
            public: false,
            nameservice: 'contenidoDetalleEventos',
            endpoint: '/crm.unidad/api/cms/Eventos/GetEventos'
        },
        contenidoFormularioCotizacion: {
            public: false,
            nameservice: 'contenidoFormularioCotizacion',
            endpoint: '/crm.unidad/api/cms/Salones/GetFormulario'
        },
        contenidoEventosUnidad: {
            public: false,
            nameservice: 'contenidoEventosUnidad',
            endpoint: '/crm.unidad/api/cms/Eventos/GetEventos'
        },
        contenidoDetalleServicioSpaUnidad: {
            public: false,
            nameservice: 'contenidoDetalleServicioSpaUnidad',
            endpoint: '/crm.unidad/api/cms/Spa/GetSpaDetalle'
        },
        contenidoDetalleSalon: {
            public: false,
            nameservice: 'contenidoDetalleSalon',
            endpoint: '/crm.unidad/api/cms/Salones/GetSalon'
        },
        preguntasFrecuentesCentroAyuda: {
            public: false,
            nameservice: 'preguntasFrecuentesCentroAyuda',
            endpoint: '/crm.footer/api/cms/Footer/GetPreguntasFrecuentesCentroAyuda'
        },

        tipoBaseLegales: {
            public: false,
            nameservice: 'tipoBaseLegales',
            endpoint: '/crm.baseslegales/api/cms/BasesLegales/GetTipos'
        },
        notificacionEmail: {
            public: false,
            nameservice: 'notificacionEmail',
            endpoint: '/crm.transversal/api/cms/Transversal/Correo/Enviar'
        },        
        modal: {
            public: false,
            nameservice: 'modal',
            endpoint: '/crm.modal/api/cms/modal/unidad'
        },
        enjoyClub: {
            tipoContenido: {
                public: false,
                nameservice: 'tipoContenido',
                endpoint: '/ecc.contenido/api/cms/Contenido/GetTiposContenido'
            },
            contenido: {
                public: false,
                nameservice: 'contenido',
                endpoint: '/ecc.contenido/api/cms/Contenido/GetContenido'
            },
            categoriaSocio: {
                public: false,
                nameservice: 'categoriaSocio',
                endpoint: '/ecc.contenido/api/cms/SocioCategoria/GetSocioCategorias'
            },
            alianzas: {
                public: false,
                nameservice: 'alianzas',
                endpoint: '/ecc.contenido/api/cms/alianzas/ConsultaAlianzas'
            },
            categoriasCliente: {
                public: false,
                nameservice: 'categoriasCliente',
                endpoint: '/ecc.transversal/api/categoriascliente'
            },
            promocionesCategoria: {
                public: false,
                nameservice: 'promocionesCategorias',
                endpoint: '/ecc.contenido/api/cms/CategoriaPromocion/GetCategoriasPromociones'
            },
            tiposPuntos: {
                public: false,
                nameservice: 'promocionesCategorias',
                endpoint: '/ecc.contenido/api/cms/puntos/gettipopuntosidiomas'
            },
            preguntasPuntos: {
                public: false,
                nameservice: 'promocionesCategorias',
                endpoint: '/ecc.contenido/api/cms/puntos/gettipopuntosidiomalistas'
            },
            respuestasPuntos: {
                public: false,
                nameservice: 'promocionesCategorias',
                endpoint: '/ecc.contenido/api/cms/puntos/getlistasitemsidiomas'
            },
            beneficios: {
                public: false,
                nameservice: 'getBeneficios',
                endpoint: '/ecc.socios.secure/api/beneficios'
            }

        }
    }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
